/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-template */
/* eslint-disable vars-on-top */
/* eslint-disable func-names */
import React, { useState, useRef } from 'react';

import axios from 'axios';

import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import TWLocale from 'date-fns/locale/zh-TW';

// material
import {
  Button,
  Grid,
  TextField,
  Tabs,
  Tab,
  Typography,
  Stack,
  Divider,
  Table,
  Box,
  Card,
  CardHeader,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  TableSortLabel,
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import addDays from 'date-fns/addDays';


import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

// components
import Page from '../components/Page';
import { BaseOptionChart } from '../components/charts';


// ----------------------------------------------------------------------
const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));
// 定義切換頁
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const isVisible = value === index;

  const boxStyles = { p: 3 };
  return (
    <div
      role="tabpanel"
      hidden={!isVisible}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {isVisible && (
        <Box sx={boxStyles}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export default function Analyze() {
  const host = localStorage.getItem('apiurl');
  // 宣告一個新的 state 變數，我們稱作為「count」。
  // 相似於 componentDidMount 和 componentDidUpdate:
  const now = useRef(new Date());
  const minidate = useRef(new Date(2020, 11, 17));
  const Region = localStorage.getItem('region');
  const [reason, setreason] = React.useState(' ');
  const [value, setValue] = React.useState(0);
  const [open, setOpen] = React.useState(false);
  const [month, setmonth] = React.useState(new Date());
  const [monthstr, setmonthstr] = React.useState('');
  const [avgspdhead, setavgspdhead] = React.useState([]);
  const [avgspddata, setavgspddata] = React.useState([]);
  const [returnavgspd, setreturnavgspd] = React.useState({ datatotal: 0, datagood: 0, databad: 0, avg: 0, sd: 0 });
  const [mileagemonthstr, setmileagemonthstr] = React.useState('');
  const [mileagemonth, setmileagemonth] = React.useState(new Date());
  const [periodmonthstr, setperiodmonthstr] = React.useState('');
  const [periodmonth, setperiodmonth] = React.useState(new Date());
  const [periodhead, setperiodhead] = React.useState([]);
  const [periodheaddata, setperiodheaddata] = React.useState([]);
  const [returnperiod, setreturnperiod] = React.useState({ datatotal: 0, datagood: 0, databad: 0 });
  const [mileagehead, setmileagehead] = React.useState([]);
  const [mileagedata, setmileagedata] = React.useState([]);
  const [returnmileage, setreturnmileage] = React.useState({ datatotal: 0, datagood: 0, databad: 0, avg: 0, sd: 0 });
  const [Datestate, setDatestate] = useState([
    {
      startDate: addDays(new Date(), -7),
      endDate: new Date(),
      key: 'selection'
    }
  ]);

  const chartOptions = merge(BaseOptionChart(), {
    stroke: { width: [3, 3, 3] },
    plotOptions: { bar: { columnWidth: '30%', borderRadius: 4 } },
    fill: { type: ['solid', 'gradient', 'solid'] },
    labels: avgspdhead,
    xaxis: { type: 'string' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} 筆`;
          }
          return y;
        }
      }
    }
  });
  const mileagedchartOptions = merge(BaseOptionChart(), {
    stroke: { width: [3, 3, 3] },
    plotOptions: { bar: { columnWidth: '30%', borderRadius: 4 } },
    fill: { type: ['solid', 'gradient', 'solid'] },
    labels: mileagehead,
    xaxis: { type: 'string' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} 筆`;
          }
          return y;
        }
      }
    }
  });
  const periodchartOptions = merge(BaseOptionChart(), {
    stroke: { width: [3, 3, 3] },
    plotOptions: { bar: { columnWidth: '30%', borderRadius: 4 } },
    fill: { type: ['solid', 'gradient', 'solid'] },
    labels: periodhead,
    xaxis: { type: 'string' },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} 筆`;
          }
          return y;
        }
      }
    }
  });

  // tab切換
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // 關閉彈跳釋出
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };



  // eslint-disable-next-line camelcase
  const getperioddistribution = async () => {
    setperiodmonthstr((periodmonth.getMonth() + 1));
    const apimonthstr = dateToStrTime(periodmonth, 0);
    await axios
      .get(`${host}/api/analyze/getperiod_distribution?Region=${Region}&month=${apimonthstr}`)
      .then((response) => {
        if (response.data.code == 0) {
          var tempperiodhead = Object.keys(response.data.data);
          var tempperioddata = Object.values(response.data.data);
          setperiodhead(tempperiodhead);


          // eslint-disable-next-line prefer-const
          let CHART_DATA = [];
          CHART_DATA.push({
            name: '趟次時段折線',
            type: 'column',
            data: tempperioddata
          });
          CHART_DATA.push({
            name: '趟次時段分佈',
            type: 'area',
            data: tempperioddata
          });
          setperiodheaddata(CHART_DATA);

          setreturnperiod(response.data.info);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });

  };
  // eslint-disable-next-line camelcase
  const getmileagedistribution = async () => {
    setmileagemonthstr((mileagemonth.getMonth() + 1));
    const apimonthstr = dateToStrTime(mileagemonth, 0);
    await axios
      .get(`${host}/api/analyze/getmileage_distribution?Region=${Region}&month=${apimonthstr}`)
      .then((response) => {
        if (response.data.code == 0) {
          var tempmileagehead = [];
          var tempmileagedata = [];
          tempmileagehead.push("-2s:" + response.data.data.left2sd);
          tempmileagehead.push("-1s:" + response.data.data.left1sd);
          tempmileagehead.push("avg:" + response.data.data.avg);
          tempmileagehead.push("+1s:" + response.data.data.right1sd);
          tempmileagehead.push("+2s:" + response.data.data.right2sd);
          setmileagehead(tempmileagehead);
          tempmileagedata.push(response.data.data.avgsd0);
          tempmileagedata.push(response.data.data.avgsd1);
          tempmileagedata.push(response.data.data.avgsd2 + response.data.data.avgsd3);
          tempmileagedata.push(response.data.data.avgsd4);
          tempmileagedata.push(response.data.data.avgsd5);
          // eslint-disable-next-line prefer-const
          let CHART_DATA = [];
          CHART_DATA.push({
            name: '里程折線',
            type: 'column',
            data: tempmileagedata
          });
          CHART_DATA.push({
            name: '里程分佈',
            type: 'area',
            data: tempmileagedata
          });
          setmileagedata(CHART_DATA);
          setreturnmileage(response.data.data);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });

  };
  // eslint-disable-next-line camelcase
  const getavgspddistribution = async () => {
    setmonthstr((month.getMonth() + 1));
    const apimonthstr = dateToStrTime(month, 0);
    await axios
      .get(`${host}/api/analyze/getaverage_speed_distribution?Region=${Region}&month=${apimonthstr}`)
      .then((response) => {
        if (response.data.code == 0) {
          var tempavgspdhead = [];
          var tempavgspddata = [];
          tempavgspdhead.push("-2s:" + response.data.data.left2sd);
          tempavgspdhead.push("-1s:" + response.data.data.left1sd);
          tempavgspdhead.push("avg:" + response.data.data.avg);
          tempavgspdhead.push("+1s:" + response.data.data.right1sd);
          tempavgspdhead.push("+2s:" + response.data.data.right2sd);

          setavgspdhead(tempavgspdhead);
          tempavgspddata.push(response.data.data.avgsd0);
          tempavgspddata.push(response.data.data.avgsd1);
          tempavgspddata.push(response.data.data.avgsd2 + response.data.data.avgsd3);
          tempavgspddata.push(response.data.data.avgsd4);
          tempavgspddata.push(response.data.data.avgsd5);
          // eslint-disable-next-line prefer-const
          let CHART_DATA = [];
          CHART_DATA.push({
            name: '均速折線',
            type: 'column',
            data: tempavgspddata
          });
          CHART_DATA.push({
            name: '均速分佈',
            type: 'area',
            data: tempavgspddata
          });
          setavgspddata(CHART_DATA);
          setreturnavgspd(response.data.data);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      })
      .then(() => {
        // always executed
      });

  };

  const dateToStrTime = (datetime1, mode) => {
    // eslint-disable-next-line no-var
    var datetime = new Date(datetime1);
    let returnstr = '';
    // eslint-disable-next-line no-var
    var year = datetime.getFullYear();
    // eslint-disable-next-line no-var
    var month = datetime.getMonth() + 1;// js從0開始取
    // eslint-disable-next-line no-var
    var date = datetime.getDate();
    // eslint-disable-next-line no-var
    var hour = datetime.getHours();
    // eslint-disable-next-line no-var
    var minutes = datetime.getMinutes();
    // eslint-disable-next-line no-var
    var second = datetime.getSeconds();

    if (month < 10) {
      month = `0${month}`;
    }
    if (date < 10) {
      date = `0${date}`;
    }
    if (hour < 10) {
      hour = `0${hour}`;
    }
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (second < 10) {
      second = `0${second}`;
    }
    // eslint-disable-next-line eqeqeq
    if (mode == 0) {
      returnstr = `${year}-${month}-${date}`;
    } else {
      returnstr = `${hour}:${minutes}:${second}`;
    }
    return returnstr;
  };
  return (
    <Page title="儀錶板 | 智慧城市移動資訊平台">
      <Container maxWidth="xl">
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            {reason}
          </Alert>
        </Snackbar>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="均速常態分布" {...a11yProps(0)} />
          <Tab label="里程常態分布" {...a11yProps(1)} />
          <Tab label="趟次時段分布" {...a11yProps(2)} />
        </Tabs>
        <TabPanel value={value} index={0}>
          <Stack direction="column" divider={<Divider orientation="column" flexItem />} spacing={3}>
            <Grid container spacing={2}>
              <Grid item xs={7} alignItems="flex-end">
                <Typography variant="h3" gutterBottom component="div">
                  {monthstr}月均速分佈
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6} alignItems="flex-end">
                    <LocalizationProvider locale={TWLocale} dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        views={['year', 'month']}
                        size="large"
                        label="選擇查看月份"
                        inputFormat="yyyy-MM"
                        value={month}
                        maxDate={now.current}
                        minDate={minidate.current}
                        onChange={(newValue) => {
                          setmonth(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6} alignItems="flex-end">
                    <Button sx={{ width: '100%', height: '100%' }} variant="contained" onClick={getavgspddistribution}>
                      查看
                    </Button>
                  </Grid>
                </Grid>


              </Grid>
              <Grid item xs={5} alignItems="flex-end">
                <></>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Card style={{ height: '500px', width: '100%' }}>
                  <CardHeader />
                  <Box sx={{ p: 3, pb: 1 }} dir="ltr">
                    <ReactApexChart type="line" series={avgspddata} options={chartOptions} />
                  </Box>
                </Card>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={2}>
                  <Typography variant="h4" gutterBottom component="div">
                    資料總筆數:{returnavgspd.datatotal}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    有效筆數:{returnavgspd.datagood}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    無效筆數:{returnavgspd.databad}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    均值:{returnavgspd.avg}公里/小時
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    標準差:{returnavgspd.sd}公里/小時
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Stack direction="column" divider={<Divider orientation="column" flexItem />} spacing={3}>
            <Grid container spacing={2}>
              <Grid item xs={7}>
                <Typography variant="h3" gutterBottom component="div">
                  {mileagemonthstr}月里程分佈
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6} alignItems="flex-end">
                    <LocalizationProvider locale={TWLocale} dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        views={['year', 'month']}
                        size="large"
                        label="選擇查看月份"
                        inputFormat="yyyy-MM"
                        value={mileagemonth}
                        maxDate={now.current}
                        minDate={minidate.current}
                        onChange={(newValue) => {
                          setmileagemonth(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6} alignItems="flex-end">
                    <Button sx={{ width: '100%', height: '100%' }} variant="contained" onClick={getmileagedistribution}>
                      查看
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <></>
              </Grid>


            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <ReactApexChart type="line" series={mileagedata} options={mileagedchartOptions} />
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={2}>
                  <Typography variant="h4" gutterBottom component="div">
                    資料總筆數:{returnmileage.datatotal}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    有效筆數:{returnmileage.datagood}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    無效筆數:{returnmileage.databad}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    均值:{returnmileage.avg}公里
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    標準差:{returnmileage.sd}公里
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <Stack direction="column" divider={<Divider orientation="column" flexItem />} spacing={3}>
            <Grid container spacing={2}>
              <Grid item xs={7}>
                <Typography variant="h3" gutterBottom component="div">
                  {periodmonthstr}月趟次時段分佈
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={6} alignItems="flex-end">
                    <LocalizationProvider locale={TWLocale} dateAdapter={AdapterDateFns}>
                      <DesktopDatePicker
                        views={['year', 'month']}
                        size="large"
                        label="選擇查看月份"
                        inputFormat="yyyy-MM"
                        value={periodmonth}
                        maxDate={now.current}
                        minDate={minidate.current}
                        onChange={(newValue) => {
                          setperiodmonth(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={6} alignItems="flex-end">
                    <Button sx={{ width: '100%', height: '100%' }} variant="contained" onClick={getperioddistribution}>
                      查看
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <></>
              </Grid>


            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <ReactApexChart type="line" series={periodheaddata} options={periodchartOptions} />
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={2}>
                  <Typography variant="h4" gutterBottom component="div">
                    資料總筆數:{returnperiod.datatotal}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    有效筆數:{returnperiod.datagood}筆
                  </Typography>
                  <Typography variant="h4" gutterBottom component="div">
                    無效筆數:{returnperiod.databad}筆
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        </TabPanel>
      </Container>
    </Page>
  );
}
